import { takeLatest, put } from "redux-saga/effects";
import { ENDPOINT } from "../../../config/endpoints";
import api from "../../../utils/apiService";
import { getLicenceExpiryStatus, setLicenceExpiryStatus } from "../../slices/LicenceExpirySlice";
import { licenceHelpers } from "@dotpe/rista-pos-common";

/**
 * Uplifted from `redux-store/saga/licenceExpirySaga` (apps/web + apps/mobile).
 *
 * FIRST SAGA on the branch, and the simplest shape: the two apps' files are IDENTICAL — same
 * imports, same body, same `takeLatest` — so `shared.ts` OWNS the saga and both platform files
 * are pure re-exports, exactly as `KeyBoardShortcuts` and `common` do for slices.
 *
 * ⚠️ All three intra-core imports are BARE FOLDER imports, and that is REQUIRED here, not
 * sloppiness (ledger hazard 16's table). `config/endpoints`, `utils/apiService` and
 * `LicenceExpirySlice` are all platform-split folders; a `shared.ts` runs on BOTH platforms, so
 * it must let each bundler pick its own variant. Naming a variant here would send mobile's
 * requests through web's axios instance.
 *
 * `licenceHelpers` comes from `@dotpe/rista-pos-common`, already a core peerDependency
 * (hazard 12) — the same package `LicenceExpirySlice`'s initialState comes from.
 */
function* fetchLicenceExpiry() {
  try {
    const response: { code: string } | Record<string, any> = yield api.request({
      method: "GET",
      url: ENDPOINT.COMMON.licenceExpiryCheck(),
    });
    if (!response.code)
      yield put(
        setLicenceExpiryStatus(
          licenceHelpers.getLicenseExpiryData(
            response as licenceHelpers.LicenceExpiryApiResponseType,
          ),
        ),
      );
  } catch (error) {
    console.log("error", error);
  }
}

export default function* root() {
  yield takeLatest(getLicenceExpiryStatus.type, fetchLicenceExpiry);
}
